export default __webpack_public_path__ + "static/media/push-pin 1.29135893.svg";